import {
  code,
  email,
  mobile,
  name,
  nickname,
  optional_string,
  password,
  pre_trimmed_string,
  required_string,
  signup_email,
} from '@/libs/schema/schema';
import { z } from 'zod';
import { USER_GENDER_MAPPER, USER_LOGIN_SNS_TYPE_MAPPER } from '../constant';

export const SnsSignupControllerReqBody = z.object({
  is_agree_notification: z.boolean(),
});

export const SignupControllerReqBody = z
  .object({
    email: signup_email,
    nickname: nickname.optional(),
    password,
    code,
  })
  .merge(SnsSignupControllerReqBody);

export const SignupEmailAndPasswordControllerReqBody = z
  .object({
    name,
    mobile: mobile.or(z.literal('')).optional(),
    email: signup_email,
    password,
    nickname: nickname.optional(),
  })
  .merge(SnsSignupControllerReqBody);

export const SigninControllerReqBody = z.object({
  email,
  password: required_string,
});

export const CreateTokenControllerReqBody = z.object({
  authorization_code: required_string,
});

export const GetProfileControllerReqBody = z.object({
  uid: required_string,
});
export const CheckJoinControllerReqBody = z.object({
  email,
});

export const UserAddressInitializer = z.object({
  name: name.optional(),
  mobile: optional_string,
  mobile2: optional_string,
  postcode: required_string,
  address: required_string,
  address_detail: optional_string,
});

export const UserAbroadAddressInitializer = z.object({
  dialing_code: optional_string,
  mobile: optional_string,
  postcode: optional_string,
  detail: optional_string,
  street: optional_string,
  city: optional_string,
  state: optional_string,
  country: optional_string,
  memo: optional_string,
  name: name.optional(),
});

export const UserAddressMutator = z.object({
  name: name.optional(),
  mobile: optional_string,
  mobile2: optional_string,
  postcode: optional_string,
  address: optional_string,
  address_detail: optional_string,
});

export const UserAbroadAddressMutator = z.object({
  dialing_code: optional_string,
  mobile: optional_string,
  postcode: optional_string,
  detail: optional_string,
  street: optional_string,
  city: optional_string,
  state: optional_string,
  country: optional_string,
  memo: optional_string,
  name: name.optional(),
});

export const ProfileChangeControllerReqBody = z.object({
  nickname: nickname.optional(),
  name: name.or(z.literal('')).optional(),
  gender: z.nativeEnum(USER_GENDER_MAPPER).optional(),
  mobile: mobile.or(z.literal('')).optional(),
  profile_image: optional_string.nullable(),
  birthday: pre_trimmed_string(z.string().length(8)).nullish(),
  user_address: UserAddressMutator.optional(),
  user_abroad_address: UserAbroadAddressMutator.optional(),
  is_agree_sms_notification: z.boolean().optional(),
  is_agree_email_notification: z.boolean().optional(),
});

export const ChangePwControllerReqBody = z.object({
  original_password: optional_string,
  password,
});

export const ChangeEmailControllerReqBody = z.object({
  email: signup_email,
  code,
});

export const SnsDisconnectControllerReqBody = z.object({
  email: signup_email,
  code,
  nickname: nickname.optional(),
  password,
  sns_type: z.nativeEnum(USER_LOGIN_SNS_TYPE_MAPPER),
});

export const SyncSigninControllerReqBody = z.object({
  uid: required_string,
});

export const WithdrawalControllerReqQuery = z.object({ uid: required_string });

export const AdminProfileChangeControllerReqBody = z.object({
  name: name.or(z.literal('')).optional(),
  mobile: mobile.or(z.literal('')).optional(),
  is_agree_email_notification: z.boolean(),
  is_agree_sms_notification: z.boolean(),
  email,
  password: optional_string,
});
